module.exports = __webpack_public_path__ + "assets/img/chibi.920bb65349bdf32baed0cc2a4e951c38.svg";